up.compiler('[data-survey-question]', (element: HTMLElement) => {
  void (async () => {
    const { mountSurveyQuestion } = await import('../survey/component')
    if (element.isConnected) {
      const destroy = mountSurveyQuestion(element)
      up.destructor(element, destroy)
    }
  })()
})
